export enum FundingType {
    declareToInsurer = 'declareToInsurer',
    freeOfCharge = 'freeOfCharge',
    fundingAccordingToSettings = 'fundingAccordingToSettings',
}
